import React from 'react';
import { Col, Row, Skeleton } from 'antd';
import { Link } from 'react-router-dom';
import { useGetPremiumFisheriesQuery } from '../premiumFisheriesSlice';
import placeholder from '../assets/images/placeholder.jpeg';
import bookableLakeIcon from '../assets/images/bookable_lake.png';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function PremiumFisheryCard({ listing }) {
  const { fishery, fishery_description } = listing;
  const image = fishery?.images?.primary || placeholder;
  const id = fishery?.public_id;
  const name = fishery?.venue_name;
  const description = fishery_description ?? fishery?.overview ?? '';

  const cardContent = (
    <div className='hot-picks__card'>
      <div className='hot-picks__image-wrap'>
        <img
          src={image}
          alt={name}
          loading='lazy'
          className='hot-picks__image'
          onError={(e) => {
            e.currentTarget.src = placeholder;
          }}
        />
        {listing?.bookable_lakes != null && (
          <div className='hot-picks__lake-badge'>
            <span className='hot-picks__lake-icon'>
              <img src={bookableLakeIcon} alt='lake' width={16} height={16} />
            </span>
            <span className='hot-picks__lake-text sb-blue-100 gBold'>
              {listing.bookable_lakes} Bookable {listing.bookable_lakes === 1 ? 'Lake' : 'Lakes'}
            </span>
          </div>
        )}
      </div>
      <div className='hot-picks__card-body'>
        <div className='hot-picks__card-name gBold fs-20'>{name}</div>
        {description ? (
          <p className='hot-picks__card-desc gMedium fs-14'>
            {description.length > 100
              ? description.slice(0, 100) + '…'
              : description}
          </p>
        ) : null}
        <span className='hot-picks__view-profile sb-blue-600 gSemiBold fs-15'>
          View Profile
        </span>
      </div>
    </div>
  );

  return (
    <Link
      to={`/fishery/${id}?source=web&redirect_from_premium_listing=yes`}
      className='hot-picks__card-link'
    >
      {cardContent}
    </Link>
  );
}

function SkeletonCard() {
  return (
    <div className='hot-picks__card'>
      <Skeleton.Image active className='hot-picks__skeleton-image' />
      <div className='hot-picks__card-body'>
        <Skeleton active paragraph={{ rows: 2 }} title={{ width: '60%' }} />
      </div>
    </div>
  );
}

export default function HotFishingPicks() {
  const { data, isFetching, isError } = useGetPremiumFisheriesQuery();
  const currentMonth = MONTHS[new Date().getMonth()];

  const listings = Array.isArray(data) ? data.slice(0, 4) : [];

  if (isError || (!isFetching && listings.length === 0)) {
    return null;
  }

  return (
    <div className='main_container_padding hot-picks__section'>
      <div className='main_container_padding__content'>
        <div className='hot-picks__header'>
          <div className='hot-picks__title-row'>
            <h2 className='hot-picks__title gBold sb-blue-800 fs-32 mg-bottom-0'>
              🔥 Hot Fishing Picks For{' '}
              <span className='gBold sb-blue-900'>{currentMonth}</span>
            </h2>
            <span className='hot-picks__premium-badge gBold'>
              PREMIUM LISTING
            </span>
          </div>
          <p className='hot-picks__subtitle gSemiBold grey-800 fs-16 mg-bottom-0'>
            A selection of great venues for you to consider for your next
            session!
          </p>
        </div>
        <Row gutter={[20, 20]} className='mg-top-20'>
          {isFetching
            ? [0, 1, 2, 3].map((i) => (
                <Col key={i} xs={24} sm={12} lg={6}>
                  <SkeletonCard />
                </Col>
              ))
            : listings.map((listing, index) => (
                <Col key={listing?.listing_id ?? index} xs={24} sm={12} lg={6}>
                  <PremiumFisheryCard listing={listing} />
                </Col>
              ))}
        </Row>
      </div>
    </div>
  );
}
